<template>
    <layout>
        <main role="main" class="background-employer-dashboard">
            <div class="container px-0 pb-5">
                <div class="row">

                    <div class="col-12 mb-4 p-md-3 px-4 mt-4">
                        <slot name="nav"/>
                        <h1 class="title font-poppins color-blue" v-if="title">{{ title }}</h1>
                        <h6 class="subtitle font-poppins color-blue" v-if="subtitle">{{ subtitle }}</h6>
                    </div>
                    <slot/>
                    <div v-if="notice" class="col-12 mb-4 p-md-3 px-4 my-lg-2">
                        <span class="font-aileron color-light-blue float-right font-size-12 py-0">
                            {{ notice }}
                        </span>
                    </div>
                </div>
            </div>
        </main>
    </layout>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
    components: {
        Layout,
    },
    props: {
        title: {
            type: String,
            default: null
        },
        subtitle: {
            type: String,
            default: null
        },
        notice: {
            type: String,
            default: null
        },
    }
}
</script>
